import Breakpoint from '../helpers/breakpoint';

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
const MobileNav = (() => {
  const DOM = {};
  const transitionBreakpoint = "xl";
  let button;

  const cacheDOM = () => {
    DOM.html			= document.querySelector( "html" );
    DOM.hamburger = document.getElementsByClassName("js-toggle-nav");
    DOM.toggleNav = document.getElementsByClassName("js-navigation");
  };

  const toggleNav = (button) => {
    Array.from(DOM.toggleNav).forEach((navEl) => {
      if (navEl.getAttribute('data-nav') === button) {
        if (navEl.classList.contains("open")) {
          navEl.classList.remove("open");
          DOM.html.classList.remove( "main-nav-open" );
        } else {
          navEl.classList.add("open");
          DOM.html.classList.add( "main-nav-open" );
        }
      }
    });
  };

  const buttonClicked = (e) => {
    button = e.currentTarget.dataset.dropdown;
    console.log(e.target);
    toggleNav(button);
  };


  const eventListeners = () => {
    let addMobileNavEventListeners = () => {
      Array.from(DOM.hamburger).forEach((nav) => {
        nav.addEventListener("click", buttonClicked);
      });
    }

    if (Breakpoint.isBreakpointDown(transitionBreakpoint)) {
      addMobileNavEventListeners();
    }

    window.addEventListener('resize', function () {
      if (Breakpoint.isBreakpointDown(transitionBreakpoint)) {
        addMobileNavEventListeners();
      }
    }, false);
  };

  const init = () => {
    cacheDOM();
    eventListeners();
  };

  return {
    init,
  };
})();

export default MobileNav;
